import { makeStyles } from '@material-ui/core';
export default makeStyles((theme) => ({
  //   Empty dashboard styling ------- Start
  loader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    height: 'inherit',
    alignItems: 'center',
  },
  errorMessage: {
    fontSize: 15,
    letterSpacing: 0.35,
    color: theme.palette.grey[600],
  },
  ///Notification Style
  notificationBox: {
    background: '#FFC29F',
    boxShadow: theme.shadows[3],
    padding: 15,
    borderRadius: 11,
    display: 'flex',
    cursor: 'pointer',
    marginBottom: 15,
    // maxWidth: 1010,
  },
  notificationTxt: {
    width: 'calc(100% - 15px)',
    paddingRight: 25,
    fontSize: 15,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    color: theme.palette.common.black,
  },
  closeIcon: {
    width: 15,
  },
  ///New Deal Box
  accordionBox: {
    // maxWidth: 1040,
    borderRadius: 11,
    boxShadow: theme.shadows[3],
    '&:before': {
      display: 'none',
    },
    '& .MuiAccordionSummary-root': {
      flexDirection: 'row-reverse',
    },
    '& .MuiAccordionSummary-content': {
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '16px 0px',
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: 62,
    },
    '&.MuiAccordion-root.Mui-expanded': {
      margin: 0,
    },
    '& .MuiIconButton-edgeEnd': {
      marginRight: 0,
    },
    '& .MuiAccordionSummary-expandIcon.Mui-expanded': {
      transform: 'rotate(90deg)',
    },
    '& .MuiAccordionDetails-root': {
      padding: 0,
    },
    '@media (max-width: 767px)': {
      marginBottom: 20,
      '&.MuiAccordion-root.Mui-expanded': {
        marginBottom: 20,
      },
    },
  },
  accordionHeadingBox: {
    alignSelf: 'center',
  },
  accordionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 20,
    letterSpacing: 0.3,
    fontWeight: 600,
    color: theme.palette.grey[500],
  },
  seeMoreDealButton: {
    height: 28,
    width: 116,
    background: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: 31,
    fontSize: 14,
    fontWeight: 700,
    cursor: 'pointer',
    textTransform: 'none',
    '&:hover': {
      background: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
  },
  newDealBox: {
    margin: '20px 50px',
    display: 'grid',
    gap: '35px',
    gridTemplateColumns: 'auto auto',
    '@media (max-width: 525px)': {
      gridTemplateColumns: 'none',
    },
    '@media (max-width: 768px)': {
      margin: '20px 30px',
    },
  },
  invstBulkList: {
    borderRadius: 11,
    background: theme.palette.primary.contrastText,
    maxWidth: '470px',
    position: 'relative',
    border: '1px solid #C4C4C4',
  },
  invstNameBox: {
    padding: '25px 30px 15px',
    display: 'flex',
    '@media (max-width: 768px)': {
      padding: '25px 20px 15px',
    },
  },
  invstNameLeft: {
    alignSelf: 'center',
    width: 'calc(100% - 200px)',
    '@media (max-width: 768px)': {
      width: 'calc(100% - 110px)',
    },
  },
  invstNameRight: {
    width: 200,
    textAlign: 'right',
    '@media (max-width: 768px)': {
      width: 110,
    },
  },
  nameTxt: {
    fontSize: 20,
    letterSpacing: 0.35,
    color: '#081F32',
    '@media (max-width: 767px)': {
      fontSize: 16,
    },
  },
  amountTxt: {
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: 0.35,
    color: theme.palette.warning.contrastText,
  },
  completeTxt: {
    fontSize: 12,
    color: theme.palette.common.black,
  },
  newDeals: {
    position: 'absolute',
    width: 128,
    height: 34,
    borderRadius: 5,
    backgroundColor: theme.palette.secondary.main,
    textAlign: 'center',
    color: theme.palette.common.white,
    top: '-13px',
    left: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: 16,
    fontWeight: 900,
    lineHeight: '22px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dashboardBox: {
    // height: 'calc(100vh - 75px)',
    // overflow: 'hidden auto',
    '@media (min-width: 1600px)': {
      width: '90%',
      // height: '100%',
      // height: 'calc(100% - 56px)',
    },
  },
  // Empty dashboard styling ------- End
  // dashboard welocme and transaction box styling ------- start
  welcomeContainer: {
    height: '100%',
    '@media (min-width: 1600px)': {
      // height: 'calc(100% - 200px)',
    },
  },
  welcomeTrxn: {
    display: 'flex',
    // marginBottom: 40,
    paddingTop: 30,
    '@media (min-width: 1600px)': {
      height: 'calc(50% - 30px)',
    },
    '@media (max-width: 767px)': {
      display: 'block',
      paddingTop: 0,
    },
  },
  protOther: {
    display: 'flex',
    marginTop: 40,
    '@media (min-width: 1600px)': {
      height: 'calc(50% - 40px)',
    },
    '@media (max-width: 767px)': {
      display: 'block',
      marginTop: 0,
    },
  },
  welcomeLtrxn: {
    width: '60%',
    background: theme.palette.primary.contrastText,
    boxShadow: theme.shadows[3],
    borderRadius: 11,
    '@media (max-width: 767px)': {
      width: '100%',
      marginBottom: 30,
    },
  },
  welcomeRtrxn: {
    width: '40%',
    marginLeft: 40,
    background: theme.palette.primary.contrastText,
    boxShadow: theme.shadows[3],
    borderRadius: 11,
    '@media (max-width: 767px)': {
      width: '100%',
      marginBottom: 30,
      marginLeft: 0,
    },
  },
  protRtrxn: {
    width: '60%',
    background: theme.palette.primary.contrastText,
    boxShadow: theme.shadows[3],
    borderRadius: 11,
    '@media (max-width: 767px)': {
      width: '100%',
      marginBottom: 30,
    },
  },
  protLtrxn: {
    width: '40%',
    marginRight: 40,
    background: theme.palette.primary.contrastText,
    boxShadow: theme.shadows[3],
    borderRadius: 11,
    '@media (max-width: 767px)': {
      width: '100%',
      marginBottom: 30,
      marginRight: 0,
    },
  },
  lTrxnCont: {
    padding: '20px 47px 45px 50px',
    '@media (max-width: 525px)': {
      padding: '20px 5% 25px',
    },
  },
  rTrxnCont: {
    padding: '20px 47px 45px 50px',
    // textAlign: 'center',
    height: '100%',
    '@media (max-width: 1024px)': {
      padding: '20px 35px 45px',
    },
    '@media (max-width: 525px)': {
      padding: '20px 5% 25px',
    },
  },
  lProtCont: {
    padding: '20px 47px 35px 50px',
    textAlign: 'center',
    minHeight: '220px',
    '@media (max-width: 767px)': {
      height: '100%',
    },
    '@media (max-width: 525px)': {
      padding: '20px 5% 25px',
    },
  },
  trxnHText: {
    fontSize: 16,
    letterSpacing: 0.3,
    fontWeight: 600,
    color: theme.palette.grey[50],
    marginBottom: 30,
    marginTop: 0,
    textAlign: 'left',
  },
  trxnHstext: {
    fontSize: 36,
    letterSpacing: 0.3,
    fontWeight: 600,
    color: theme.palette.common.black,
    marginBottom: 20,
    marginTop: 0,
    '@media (max-width: 525px)': {
      fontSize: 25,
    },
  },
  trxnCText: {
    fontSize: 16,
    letterSpacing: 0.3,
    fontWeight: 400,
    color: theme.palette.grey[500],
    marginBottom: 20,
    marginTop: 0,
  },
  helpUText: {
    fontSize: 16,
    letterSpacing: 0.3,
    fontWeight: 400,
    color: theme.palette.grey[500],
    marginBottom: 20,
    marginTop: 0,
    alignSelf: 'center',
  },
  trxnsImage: {
    margin: '15px auto 25px',
    display: 'block',
  },
  trxnButton: {
    height: 57,
    width: 256,
    background: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    textTransform: 'capitalize',
    '&:hover': {
      background: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
  },
  // dashboard welocme and transaction box styling ------- end
  /// Welcome popup styling
  welcomeBoxBody: {
    maxWidth: 600,
    margin: 'auto',
    textAlign: 'center',
    paddingTop: 10,
  },
  welcomeImgImage: {
    marginBottom: 25,
  },
  welcomeModalHeaderText: {
    fontSize: 20,
    lineHeight: '28px',
    letterSpacing: '0.35px',
    marginBottom: 10,
    marginTop: 10,
    color: theme.palette.common.black,
    fontWeight: 600,
    textAlign: 'center',
  },
  welcomeModalText: {
    fontSize: 15,
    lineHeight: '28px',
    letterSpacing: '0.35px',
    marginBottom: 20,
    textAlign: 'center',
  },
  continueAndLogoutButtonBox: {
    marginTop: 20,
    textAlign: 'center',
  },
  continueBtn: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    padding: '12px 16px',
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: 15,
    cursor: 'pointer',
    height: 58,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
  },
  logoutBtn: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    padding: '12px 16px',
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: 15,
    cursor: 'pointer',
    width: 152,
    height: 58,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
    marginLeft: 20,
  },
  continueBtnBox: {
    width: '100%',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    // padding: '12px 16px',
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: 15,
    cursor: 'pointer',
    height: 58,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
    marginTop: 20,
  },
  checkBoxAgree: {
    paddingTop: 18,
    textAlign: 'center',
  },
  agreeTerms: {
    fontSize: 14,
    letterSpacing: 0.35,
    color: theme.palette.common.black,
    opacity: 0.6,
  },
  termAndConditionLink: {
    color: theme.palette.grey.A200,
    cursor: 'pointer',
  },

  // custome switch base styling --------- start
  switchBox: {
    '@media (max-width: 767px)': {
      textAlign: 'center',
    },
    marginBottom: 25,
  },
  switchRoot: {
    width: '116px',
    height: '28px',
    padding: '0px',
    alignSelf: 'center',
  },
  switchBase: {
    color: '#818181',
    padding: '1px',
    '&$checked': {
      '& + $track': {
        backgroundColor: '#E5E5E5',
      },
      '& $thumb:after': {
        content: "'TV'",
      },
    },
    '&$disabled + $track': {
      backgroundColor: '#E5E5E5',
      opacity: 0.5,
    },
    '&.MuiSwitch-colorSecondary.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: '#E5E5E5',
      opacity: '0.5 !important',
    },
  },
  thumb: {
    color: theme.palette.secondary.main,
    width: '58px',
    height: '28px',
    margin: '-1px',
    borderRadius: 31,
    '&:after': {
      color: theme.palette.common.white,
      fontSize: 14,
      fontWeight: 700,
      position: 'absolute',
      top: 5,
      right: 10,
      left: 10,
      content: "'NAV'",
    },
  },
  track: {
    borderRadius: '31px',
    backgroundColor: '#E5E5E5',
    opacity: '1 !important',
    '&:after, &:before': {
      color: 'black',
      fontSize: 14,
      fontWeight: 700,
      position: 'absolute',
      top: 5,
    },
    '&:after': {
      content: "'NAV'",
      left: 20,
    },
    '&:before': {
      content: "'TV'",
      right: 20,
    },
  },
  checked: {
    color: '#FF6829 !important',
    transform: 'translateX(58px) !important',
  },
  // custome switch base styling --------- end
  graphHeader: {
    display: 'flex',
    // marginBottom: 32,
    marginBottom: 10,
    justifyContent: 'space-between',
  },
  spvLabelText: {
    fontSize: 18,
    fontWeight: 600,
  },
  graphPHText: {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: '35px',
    textAlign: 'center',
    marginBottom: 2,
  },
  gDollorText: {
    fontSize: 20,
    position: 'relative',
    top: -2,
    color: theme.palette.grey[200],
  },
  graphPSText: {
    fontSize: 14,
    textAlign: 'center',
    color: theme.palette.info.dark,
  },
  chatGraphBox: {
    maxWidth: 650,
    // margin: '30px auto 0',
    margin: '10px auto 0',
  },
  tableRow: {
    backgroundColor: 'transparent !important',
  },
  tableHead: {},
  tableHeadCell: {
    backgroundColor: 'transparent !important',
    padding: '0 16px',
    fontWeight: 600,
    fontSize: 14,
  },
  tableCell: {
    borderTop: '1px solid #dedede',
    borderBottom: '1px solid #dedede',
    fontWeight: 600,
    fontSize: 14,
    letterSpacing: 0.3,
    padding: '12px 15px',
  },
  tableAmonut: {
    color: theme.palette.secondary.main,
    fontWeight: 600,
    fontSize: 14,
  },
  tableTotalAmonut: {
    fontWeight: 600,
    fontSize: 14,
    color: '#09CC84',
  },
  viewMoreBox: {
    textAlign: 'right',
    paddingTop: 5,
  },
  viewMoreTxt: {
    color: theme.palette.grey.A200,
    display: 'inline',
    fontSize: 14,
    letterSpacing: 0.3,
  },
  rightIcon: {
    fill: theme.palette.grey.A200,
    position: 'relative',
    top: 6.5,
  },
  investPopUp: {
    '& .MuiBackdrop-root': {
      background: theme.palette.primary.main,
    },
    '& .MuiDialog-paperFullWidth': {
      padding: 0,
      width: '100%',
      maxHeight: '100%',
      height: '100%',
      margin: 0,
      '@media (max-width: 767px)': {
        borderRadius: 0,
      },
    },
    '& .MuiDialog-paperWidthLg': {
      maxWidth: '100%',
    },
    '& .MuiTypography-h5': {
      top: 25,
      right: 25,
      zIndex: 1,
    },
    '& .MuiDialogContent-root': {
      padding: 0,
      overflowY: 'hidden',
      height: '100%',
    },
    '& .MuiTypography-h6': {
      padding: 0,
    },
    '@media (max-width: 767px)': {
      padding: '0px',
    },
  },
}));
